module.exports = __webpack_public_path__ + "media/landing_page/dollar-sign-icon-c61f2c36.svg";